<template>
  <div class="h-48 border border-blue-200 flex flex-row justify-center m-4 rounded" v-observe-visibility='onVisible'>
    <div v-if='loading' class="spinner text-2xl" />
    <p v-if='loading' class="ml-8 self-center text-lg text-center text-white">Loading...</p>
    <p v-else-if='ended' class="ml-8 self-center text-lg text-center text-white">The End</p>
    <p v-else class="ml-8 self-center text-lg text-center text-white">More</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading:false,
      ended:false
    }
  },
  methods:{
    onVisible(visible) {
      if (visible) {
        if (!this.ended) {
          this.$emit('load-more', this);
        }
      } else {
      }
    },
    setLoading(loading) {
      this.loading = loading;
    },
    setEnded(ended) {
      this.ended = ended;
    }
  }
}
</script>
